/* eslint-disable import/no-unresolved */
import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { swalMessages } from 'src/constants';
import UsersPermits from 'src/pages/AdminControl/UsersAdmin/UsersPermits';
import bussinesUnits from 'src/services/bussinesUnits';
import administratorService from 'src/services/administratorService';
import { Context } from 'src/context/Contex';
import swal from 'sweetalert';

const PermistContainer = () => {
  const [units, setUnits] = useState([]);
  const [unitsUser, setUnitsUser] = useState([]);
  const [permit, setPermit] = useState([]);
  const [permits, setPermits] = useState([]);
  const [user, setUser] = useState([]);
  const { userId } = useContext(Context);
  const history = useHistory();

  /*= =======================================================================
    Get permits Users
  ====================================================== ================== */
  const getPermit = () => {
    administratorService.getPermiso(userId.id)
      .then((response) => {
        setPermit(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /*= =======================================================================
    Get  User
  ====================================================== ================== */
  const getUsers = () => {
    administratorService.getUser(userId.id)
      .then((response) => {
        setUser(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /*= =======================================================================
    Get permits
  ====================================================== ================== */
  const getPermits = () => {
    administratorService.getPermisos()
      .then((response) => {
        setPermits(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /*= =======================================================================
  Get Unidades de Negocio
======================================================================== */

  const getBussinessUnits = () => {
    bussinesUnits.getUnidades()
      .then((response) => {
        setUnits(response.data.data);
      })
      .catch((error) => {
        console.log('ErrorList', error);
      });
  };

  /*= =======================================================================
    Get unidades de Users
  ====================================================== ================== */

  const getUnitUser = () => {
    bussinesUnits.getUnitsUser(userId.id)
      .then((response) => {
        setUnitsUser(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getBussinessUnits();
    getPermits();
    getUnitUser();
    getPermit();
    getUsers();
  }, []);

  /*= =======================================================================
    handleUpdate User
  ========================================================================= */
  const handleUpdate = (props) => {
    administratorService.putUser(props)
      .then((response) => {
        if (response.data.success === 0) {
          swal(swalMessages.GENERAL_ERROR);
        } else {
          swal(swalMessages.SUCCESSFUL_MESSAGE);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /*= =======================================================================
    handleUpdate Password
  ========================================================================= */
  const handleUpdatePass = (props) => {
    administratorService.putUser(props)
      .then((response) => {
        if (response.data.success === 0) {
          swal(swalMessages.GENERAL_ERROR);
        } else {
          swal(swalMessages.SUCCESSFUL_MESSAGE);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /*= =======================================================================
    handleUpdate Permit User
  ========================================================================= */
  const handleUpdatePermit = (props) => {
    administratorService.postPermiso(props)
      .then(() => {
        getPermit();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /*= =======================================================================
    handleDelete Permit User
  ========================================================================= */
  const handleDeletePermit = (props) => {
    administratorService.deletePermisos(props.usuario_id, props.permiso_id)
      .then(() => {
        getPermit();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /*= =======================================================================
    handleDelete Permit Unit
  ========================================================================= */
  const handleDeleteUnit = (props) => {
    administratorService.deleteUnit(props.unidad_negocio_id)
      .then(() => {
        getUnitUser();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  /*= =======================================================================
    handleDelete Permit Unit
  ========================================================================= */
  const handleUpdateUnit = (props) => {
    administratorService.updateUnit(props)
      .then(() => {
        getUnitUser();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  if (userId.id === undefined) {
    history.push('/adminusers');
  }

  return (
    <>
      <UsersPermits
        user={user}
        onUpdatePass={handleUpdatePass}
        onUpdateUser={handleUpdate}
        unitsUser={unitsUser}
        units={units}
        permit={permit}
        permits={permits}
        onDeleteUnit={handleDeleteUnit}
        onUpdateUnit={handleUpdateUnit}
        onUpdatePermit={handleUpdatePermit}
        onDeletePermit={handleDeletePermit}
      />
    </>

  );
};

export default PermistContainer;
